// Znormalizowany kształt wybranego Paczkomatu InPost przekazywany do zamówienia.
// To jedyne źródło prawdy o tym, jakie pola Paczkomatu przechowujemy w aplikacji
// i zapisujemy w MongoDB razem z zamówieniem.
//
// UWAGA bezpieczeństwa: tu trafiają wyłącznie dane PUBLICZNE punktu odbioru.
// Żadnych tokenów API ShipX/Points — te żyją tylko po stronie backendu.
export interface InpostParcelLocker {
  name: string;      // kod/nazwa punktu, np. "KRA123"
  address: string;   // pełny adres (ulica + numer lub linia adresu z Geowidgetu)
  city: string;      // miasto
  postCode: string;  // kod pocztowy (jeśli dostępny)
}

// Mapuje surowy obiekt punktu z eventu `onpoint` Geowidgetu v5 na nasz model.
// Geowidget v5 zwraca m.in.: { name, address: { line1, line2 },
// address_details: { city, post_code, street, building_number } }.
export function normalizeInpostPoint(point: any): InpostParcelLocker | null {
  const name = String(point?.name ?? '').trim();
  if (!name) {
    return null;
  }
  const details = point?.address_details ?? {};
  const street = String(details.street ?? '').trim();
  const building = String(details.building_number ?? '').trim();
  const composedStreet = [street, building].filter(Boolean).join(' ').trim();
  const fallbackLine = String(point?.address?.line1 ?? '').trim();
  return {
    name: name,
    address: composedStreet || fallbackLine,
    city: String(details.city ?? '').trim(),
    postCode: String(details.post_code ?? '').trim()
  };
}
